import psl_ui from '../../libs/psl_ui.js';
import {wait} from '../../libs/psl_polyfills.js';

import audio from '../../components/audio.js';

import instructions from '../../components/instructions/component.js';
import steps from '../../components/steps/component.js';

import './style.scss';
import template from './template.pst';

import message from '../../components/message/component.js';

psl_ui.templates.add('page_billboard',template);

const {el,rpoints}=psl_ui.templates.render('page_billboard');

let _state={
	bkg:0,
	label:0,
	img:0,
};

for(let i=1;i<4;i++){
	rpoints[`option_${i}`].addEventListener('click',()=>{
		_choice(i);
	});
}

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/1080;
		height=height/1920;
	}

	coef = Math.min(width,height);

	rpoints.container.style.transform=`scale3d(${coef},${coef},1)`;
}

let _step='bkg';

let _clb;

const _unblur = ()=>{
	rpoints.choice_title.focus();
	rpoints.game_container.classList.remove('blur');

	for(let i=1;i<4;i++){
		rpoints[`option_${i}`].classList.remove('disabled');
		rpoints[`option_${i}`].removeAttribute('tabindex');
		rpoints[`option_${i}`].removeAttribute('aria-hidden');
	}
	rpoints.choice_title.removeAttribute('aria-hidden');
	steps.rpoints.btn.removeAttribute('aria-hidden');
}

const init = (clb)=>{

	instructions.text='Choose a background, image, and title to create your own safety billboard.';
	instructions.append(rpoints.container,_unblur);

	rpoints.choices.appendChild(steps.view);
	rpoints.game_container.classList.add('blur');

	_state.bkg=0;
	_state.label=0;
	_state.img=0;

	_step='bkg';

	_clb=clb;

	_render();

	for(let i=1;i<4;i++){
		rpoints[`option_${i}`].classList.add('disabled');
		rpoints[`option_${i}`].setAttribute('tabindex','-1');
		rpoints[`option_${i}`].setAttribute('aria-hidden','true');
	}

	rpoints.choice_title.setAttribute('aria-hidden','true');
	steps.rpoints.btn.setAttribute('aria-hidden','true');
}

const _render_banner = () => {
	let cls='banner';

	if(_state.bkg) cls+=` bkg_${_state.bkg}`;
	if(_state.label) cls+=` label_${_state.label}`;
	if(_state.img) cls+=` img_${_state.img}`;

	rpoints.banner.className=cls;
}

const _render_option_selected=(selected)=>{
	for(let i=1;i<4;i++){
		rpoints[`option_${i}`].classList[selected===i?'add':'remove']('selected');
		rpoints[`option_${i}`].setAttribute('aria-checked',selected===i);
	}
}

const _alts={
	bkg:[
		'',
		'Orange background with border of diagonal black stripes',
		'Yellow background with a border of alternating yellow and black stripes',
		'Black background with a border of alternating black and orange stripes'
	],
	label:[
		'',
		'Phones down, stay focused',
		'Protect our workers',
		'Respect Georgia Work Zones'
	],
	img:[
		'',
		'A cell phone crossed out',
		'A construction worker holding a \'Slow\' sign',
		'A construction cone'
	],
}

const _render_options = async ()=>{
	for(let i=1;i<4;i++){
		rpoints[`option_${i}`].classList.add('instant');
		rpoints[`option_${i}`].innerHTML=_alts[_step][i];
	}

	switch(_step){
		case 'bkg':
			rpoints.choices.setAttribute('aria-label','Choose a background');
			rpoints.choice_title.innerHTML='Choose a background:';
			rpoints.choice_options.className='options bkg';
			_render_option_selected(_state.bkg);
		break;
		case 'label':
			rpoints.choices.setAttribute('aria-label','Choose a title');
			rpoints.choice_title.innerHTML='Choose a title:';
			rpoints.choice_options.className='options label';
			_render_option_selected(_state.label);
		break;
		case 'img':
			rpoints.choices.setAttribute('aria-label','Choose an image');
			rpoints.choice_title.innerHTML='Choose an image:';
			rpoints.choice_options.className='options img';
			_render_option_selected(_state.img);
		break;
	}

	await wait(1);

	for(let i=1;i<4;i++) rpoints[`option_${i}`].classList.remove('instant');
}

const _choice = (i) => {
	_state[_step]=i;
	_render_option_selected(i);

	_render_banner();
	_render_steps();

	const _choices = [];

	switch(_step){
		case 'bkg':
			_choices.push(`a ${_alts.bkg[_state.bkg]} background`);
			if(_state.label) _choices.push(`a title of "${_alts.label[_state.label]}"`);
			if(_state.img) _choices.push(`${_alts.img[_state.img]} icon`);
		break;
		case 'label':
			_choices.push(`a title of "${_alts.label[_state.label]}"`);
			if(_state.bkg) _choices.push(`a ${_alts.bkg[_state.bkg]} background`);
			if(_state.img) _choices.push(`${_alts.img[_state.img]} icon`);

		break;
		case 'img':
			_choices.push(`${_alts.img[_state.img]} icon`);
			if(_state.label) _choices.push(`a title of "${_alts.label[_state.label]}"`);
			if(_state.bkg) _choices.push(`a ${_alts.bkg[_state.bkg]} background`);
		break;
	}

	let msg='';

	switch(_choices.length){
		case 1:
			msg = `You chose ${_choices[0]}`;
		break;
		case 2:
			msg = `You chose ${_choices[0]} and ${_choices[1]}`;
		break;
		case 3:
			msg = `You chose ${_choices[0]}, ${_choices[1]} and ${_choices[2]}`;
		break;
	}

	message.show(msg);
}

const _next = () => {
	switch(_step){
		case 'bkg':
			_set_step('label');
		break;
		case 'label':
			_set_step('img');
		break;
		case 'img':
			audio.play('finished');
			_ext.hide();
			_state.msg = `You've created a billboard with a ${_alts.bkg[_state.bkg]} background, a title of "${_alts.label[_state.label]}" and ${_alts.img[_state.img]} icon`;
			_clb(_state);
		break;
	}
}

const _set_step = (step) => {
	_step = step;
	_render();
	rpoints.choice_title.focus();
}

const _render = () => {
	_render_steps();
	_render_options();
	_render_banner();
}

const _render_steps = () => {
	switch(_step){
		case 'bkg':
			steps.render({
				btn:{
					label:'Next',
					cls:_state.bkg?'red':'grey',
					clb:_state.bkg?_next:undefined
				},
				steps:[{cls:'current'},{cls:''},{cls:''}]
			});
		break;
		case 'label':
			steps.render({
				btn:{
					label:'Next',
					cls:_state.label?'red':'grey',
					clb:_state.label?_next:undefined
				},
				steps:[{cls:'finished',clb:()=>_set_step('bkg')},{cls:'current'},{cls:''}]
			});
		break;
		case 'img':
			steps.render({
				btn:{
					label:'Finish',
					cls:_state.img?'green':'grey',
					clb:_state.img?_next:undefined
				},
				steps:[{cls:'finished',clb:()=>_set_step('bkg')},{cls:'finished',clb:()=>_set_step('label')},{cls:'current'}]
			});
		break;
	}
}

const _ext={
	show:({
		parent,
		clb
	})=>{
		parent.insertBefore(el,parent.firstChild);
		_resize();
		init(clb);
	},
	hide:()=>{
		if(el.parentNode) el.parentNode.removeChild(el);
	}
}

export default _ext;
